<template>
  <div class="attribute-templates">
    <attribute-templates-form
      v-if="isAttributeFormShow"
      maxWidth="400px"
      maxHeight="100vh"
      :attribute="attribute"
      :languages="languages"
      :attributeTypes="attributeTypes"
      :references="references"
      :show="isAttributeFormShow"
      @close="AttributeFormHide"
      @save="AttributeFormSave"
    ></attribute-templates-form>

    <h3>{{ $t("attribute_templates_title") }}</h3>
    <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">
      <el-table-column
        prop="code"
        :label="$t('attribute_templates_table_code')"
      ></el-table-column>

      <el-table-column
        prop="name"
        :label="$t('attribute_templates_table_name')"
      ></el-table-column>

      <el-table-column
        prop="type"
        :label="$t('attribute_templates_table_type')"
      >
        <template slot-scope="scope">
          {{ getAttributeName(scope.row.type) }}
        </template>
      </el-table-column>

      <el-table-column prop="noTranslationRequired" align="center">
        <template slot="header">
          <span :title="$t('attribute_templates_attr_no_translation_hint')">
            {{ $t("attribute_templates_table_alone") }}
          </span>
        </template>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.noTranslationRequired" type="success">
            {{ $t("attribute_templates_table_alone_yes") }}
          </el-tag>
          <el-tag v-else>{{ $t("attribute_templates_table_alone_no") }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="comment"
        :label="$t('attribute_templates_table_comment')"
      ></el-table-column>

      <el-table-column
        fixed="right"
        :label="$t('attribute_templates_table_operation')"
        width="120"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            :title="$t('attribute_templates_edit_title')"
            @click="changeAttribute(scope.row.id)"
          ></el-button>

          <el-button
            type="warning"
            icon="el-icon-delete"
            :title="$t('attribute_templates_delete_title')"
            @click="deleteAttribute(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="attribute-templates__actions">
      <el-button
        class="attribute-templates__actions_item"
        type="primary"
        @click="createAttribute"
      >
        {{ $t("attribute_templates_add") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import AttributeTemplatesForm from "./attribute-templates-form/AttributeTemplatesForm.vue";
import * as service from "@/domain/settings/attributeTemplates.service";

import { Attribute } from "@/mixins";

export default {
  name: "AttributeTemplates",
  components: {
    AttributeTemplatesForm
  },
  props: {
    items: Array,
    languages: Array,
    references: Array,
    attributeTypes: Array,
    loading: Boolean
  },
  mixins: [Attribute],
  data() {
    return {
      isAttributeFormShow: false,
      attributeId: undefined
    };
  },
  computed: {
    tableData() {
      if (this.items && this.items.length > 0) {
        return service.getTableData(this.items, this.languages);
      }
      return [];
    },
    attribute() {
      if (this.attributeId) {
        return service.getAttribute(this.tableData, this.attributeId);
      }
      return null;
    }
  },
  methods: {
    AttributeFormHide() {
      this.isAttributeFormShow = false;
      this.attributeId = undefined;
    },
    AttributeFormSave(obj) {
      let eventName = obj.id === undefined ? "create" : "update";
      this.$emit(eventName, service.prepareToSave(obj, this.languages));
    },
    createAttribute() {
      this.isAttributeFormShow = true;
    },
    changeAttribute(id) {
      this.attributeId = id;
      this.isAttributeFormShow = true;
    },
    deleteAttribute(id) {
      this.$emit("delete", { id });
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.attribute-templates {
  width: 100%;

  .attribute-templates__actions {
    position: sticky;
    bottom: -5px;
    margin-top: 10px;
    padding: 10px 0;
    text-align: right;
    width: 100%;
    background-color: $free_zone_color;
    z-index: 4;

    .attribute-templates__actions_item {
      margin: 0 10px;
    }
  }
}
</style>
